<template>
  <div></div>
</template>

<script>
import PageTemplate from '@/spa/components/page-template/PageTemplate'; //eslint-disable-line
import Board from '@/spa/components/table/BoardTable'; //eslint-disable-line

export default {
  name: 'CommonBoardItems',
  components: {
    PageTemplate, //eslint-disable-line
    Board, //eslint-disable-line
  },
  data() {
    return {
    };
  },
  methods: {
    async insertRow(name) {
      const result = await this.$store.dispatch(name);

      this.$toast(result.message);
      return result.response.id;
    },

    async deleteRow(name, rows) {
      const result = await this.$store.dispatch(name, rows);
      this.$toast(result.message);
    },
  },
  computed: {
    isFold() {
      return this.$store.getters.isFold;
    },

    httpOptions() {
      return { headers: { Authorization: this.$store.getters.getToken } };
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/spa/components/board/CommonBoardItems.vue